import request from '@/utils/request'

const API_PREFIX = '/uni/product';

// 产品分类
export function getCategoryList(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/category/listG`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 产品
export function getProductList(query, pageReq) {
    return request({
        url:  `${API_PREFIX}/listG`,
        method: 'post',
        data: query,
        params: pageReq
    })
}

// 查询产品字段配置列表
export function listProductField() {
    return request({
        url: '/uni/product-fields/listG',
        method: 'get',
    })
}
